import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import { Bookmark, BookmarkType } from "marketplace/bookmarks/bookmark";
import BookmarkedCompanySchema, { BookmarkedCompanyParams, BookmarkedCompanyJSON } from "marketplace/bookmarks/company-bookmarks/_schema/bookmarked-company-schema";
import Entity from '_framework/entities/entity';

export default class BookmarkedCompany extends Entity<BookmarkedCompany, BookmarkedCompanyJSON, BookmarkedCompanyParams> implements Bookmark {
  public static get EXAMPLE(): BookmarkedCompany {
    return new BookmarkedCompany({
      id: Guid.generate(),
      createdDate: AHDate.TODAY,
      companyId: Guid.generate()
    });
  }

  public static create(values: BookmarkedCompanyParams): BookmarkedCompany {
    const parsed = BookmarkedCompanySchema.validate(values);
    return new BookmarkedCompany(parsed);
  }

  public static fromJSON(json: BookmarkedCompanyJSON): BookmarkedCompany {
    const parsed = BookmarkedCompanySchema.deserialize(json);
    return new BookmarkedCompany(parsed);
  }

  public static fromJSONArray(jsonArray: BookmarkedCompanyJSON[]): BookmarkedCompany[] {
    return jsonArray.map((json) => BookmarkedCompany.fromJSON(json));
  }


  public readonly id: Guid;
  public readonly createdDate: AHDate;
  public readonly companyId: Guid;

  public get type(): BookmarkType {
    return BookmarkType.Company;
  }

  public constructor(params: BookmarkedCompanyParams) {
    super(params);
    this.id = params.id;
    this.createdDate = params.createdDate;
    this.companyId = params.companyId;
  }


  public toJSON(): BookmarkedCompanyJSON {
    return BookmarkedCompanySchema.serialize(this);
  }

  public valueOf(): BookmarkedCompanyJSON {
    return this.toJSON();
  }

  public toString(): string {
    return `Bookmarked Company: 
        Id: ${this.id.toString()}
        CreatedDate: ${this.createdDate.toString()}
        CompanyId: ${this.companyId.toString()}
      )`;
  }

  public isEqualTo(other: BookmarkedCompany | null | undefined): boolean {
    return Boolean(other
      && this.id.isEqualTo(other.id)
      && this.createdDate.isEqualTo(other.createdDate)
      && this.companyId.isEqualTo(other.companyId)
    );
  }
}
